import { LoginPage } from '@/components/pages'

const LoginRoute = () => {
  return <LoginPage />
}
LoginRoute.layouts = 'default'
LoginRoute.displayName = 'LoginRoute'
export default LoginRoute
